import { Link } from "react-router-dom";
import { routePaths } from "../../routes";

const SecondPage = () => {
  return (
    <div>
      <h1>Second Page</h1>
      <Link to={routePaths.dashboard}>Go to Dashboard</Link>
    </div>
  );
};

export default SecondPage;
